module.exports = __webpack_public_path__ + "img/WechatIMG200.c419d7fe.png";